<template>
  <!-- Feature Section start -->

  <section id="operationModel" class="about">
    <div class="about-decor">
      <div class="about-circle1"><img :src='"../../assets/images/team1-blue.png"' alt="team1"></div>
      <div class="about-circle2"><img :src='"../../assets/images/main-banner1-blue.png"' alt="banner1"></div>
    </div>
    <div class="container">
      <div class="row ">
        <div class="col-md-12 col-lg-5">
          <div class="about-contain">
            <div>
              <h2 class="title text-center">{{$t("operationModel.Title")}}</h2>
              <div class="row sm-mb">
                <div class="col-12 col-md-6">
                  <ul class="feature-style">
                    <li class="abt-hover">
                      <div class="about-icon" style="left: 0px;  ">
                        <div class="icon-hover">
                          <img :src='"../../assets/images/numbers/1.svg"' alt="">
                        </div>
                      </div>
                      <div class="feature-subtitle" style="padding-left: 55px; padding-top: 3px">
                        <h3>{{$t("operationModel.operation.1.Title")}}</h3>
                      </div>
                      <div >
                        <p class="margMobile">{{$t("operationModel.operation.1.Body")}}</p>
                      </div>
                    </li>
                    <li class="abt-hover hiddenxs">
                      <div class="about-icon" style="left: 0px;  ">
                        <div class="icon-hover">
                          <img :src='"../../assets/images/numbers/3.svg"' alt="">
                        </div>
                      </div>
                      <div class="feature-subtitle" style="padding-left: 55px; padding-top: 3px">
                        <h3>{{$t("operationModel.operation.3.Title")}}</h3>
                      </div>
                      <div>
                        <p class="margMobile">{{$t("operationModel.operation.3.Body")}}</p>
                      </div>
                    </li>
                    <li class="abt-hover visiblexs">
                      <div class="about-icon" style="left: 0px;  ">
                        <div class="icon-hover">
                          <img :src='"../../assets/images/numbers/2.svg"' alt="">
                        </div>
                      </div>
                      <div class="feature-subtitle" style="padding-left: 55px; padding-top: 3px">
                        <h3>{{$t("operationModel.operation.2.Title")}}</h3>
                      </div>
                      <div>
                        <p class="margMobile">{{$t("operationModel.operation.2.Body")}}</p><div class="visiblexs" style="margin-top: 60px"></div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="col-12 col-md-6 sm-m-top">
                  <ul class="feature-style">
                    <li class="abt-hover hiddenxs">
                      <div class="about-icon" style="left: 0px;  ">
                        <div class="icon-hover">
                          <img :src='"../../assets/images/numbers/2.svg"' alt="">
                        </div>
                      </div>
                      <div class="feature-subtitle" style="padding-left: 55px; padding-top: 3px">
                        <h3>{{$t("operationModel.operation.2.Title")}}</h3>
                      </div>
                      <div>
                        <p class="margMobile">{{$t("operationModel.operation.2.Body")}}</p><div class="hiddenxs"><br/></div>
                      </div>
                    </li>
                    <li class="abt-hover visiblexs marginTop30">
                      <div class="about-icon" style="left: 0px;  ">
                        <div class="icon-hover">
                          <img :src='"../../assets/images/numbers/3.svg"' alt="">
                        </div>
                      </div>
                      <div class="feature-subtitle" style="padding-left: 55px; padding-top: 3px">
                        <h3>{{$t("operationModel.operation.3.Title")}}</h3>
                      </div>
                      <div>
                        <p class="margMobile">{{$t("operationModel.operation.3.Body")}}</p>
                      </div>
                    </li>
                    <li class="abt-hover hidden-xs-only">
                      <div class="about-icon" style="left: 0px;  ">
                        <div class="icon-hover">
                          <img :src='"../../assets/images/numbers/4.svg"' alt="">
                        </div>
                      </div>
                      <div class="feature-subtitle" style="padding-left: 55px; padding-top: 3px">
                        <h3>{{$t("operationModel.operation.4.Title")}}</h3>
                      </div>
                      <div>
                        <p class="margMobile">{{$t("operationModel.operation.4.Body")}}</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-7 d-medium-none displayNone">
          <div class="about-right">
            <div class="about-phone">
              <img  :src='"../../assets/images/notebook_right_2.png"' class="img-fluid" alt="aboutus">
            </div>
          </div>
        </div>
      </div>
    </div>
</section>
<!-- Feature Section End -->
</template>
<script>
export default {
  name: "OperationModel"
}
</script>

<style scoped>
  @media only screen and (max-width: 991px) {
    .displayNone {
      display: none;
    }}

  @media only screen and (max-width: 768px) {
    .feature-style li {
      margin-bottom: 30px;
    }
    .feature-subtitle h3 {
      padding-bottom: 8px;
      padding-top: 8px;
    }
    .margMobile{
      margin-left: 55px;
    }
    .hiddenxs {
      display: none !important;
    }

    .visiblexs{
      display:inherit;
    }

    .marginTop30{
      margin-top: -30px;
    }
  }
  @media only screen and (min-width: 769px) {
  .visiblexs{
    display: none !important;
  }
    .img-fluid{
      max-width: 700px;
    }
  }

  @media only screen and (min-width: 1400px) {
    .container{
      max-width: 1100px;
    }
  }

  @media only screen and (min-width: 1600px) {
    .container{
      max-width: 1300px;
    }
    .img-fluid{
      max-width: 900px;
    }
  }

  @media only screen and (min-width: 1900px) {
    .container{
      max-width: 1500px;
    }}
</style>



// WEBPACK FOOTER //
// src/components/servicePage/operationmodel.vue